import { Badge } from "@chakra-ui/react";

const NotificationBadge = ({ count }: any) => {
    return (
        <Badge
            borderRadius="full"
            bg="red.500"
            color="white"
            fontSize="0.8em"
            minWidth="24px"
            px="2"
            height="24px"
            display="flex"
            alignItems="center"
            justifyContent="center"
        >
            {count}
        </Badge>
    );
}

export default NotificationBadge;
